import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledMainTitleWrapper = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const StyledTitleContainer = styled(FlexColumn)`
    gap: 8px;
`;

export const StyledSubtitleWrapper = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;
